// ESM-Huelle um lib/scripts/pos/CLS_CBonEntryOps.js (Phase 4, Welle 3) -
// Positionen/Entries, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var i, me, rb;


function CBonEntryOps() {}

CBonEntryOps.prototype.addEntryMVC = function (type) { //monatlicher Beleg
    var BonManagerClass = this;

    var defret = $.Deferred();

    $.when(Trans.openBon(null)).then(function (currentBonId) {
        BonManagerClass.currentBonId = currentBonId;
        $.when(Trans.closeBon(currentBonId, type, null)).then(function () {
            defret.resolve(currentBonId);
        });

    });
    return defret.promise();
}

CBonEntryOps.prototype.preAddEntryPOS = function (quantity, productId, productPrice, freeProd) {
    var BonManagerClass = this;
    var defret = $.Deferred();
    // check quantity, correct for 1 if less
    if (!(quantity > 0))
        quantity = 1;
    else
        quantity = parseFloat(quantity);


    if (quantity > 999) {
        var text = POS.lang.getText("MESSAGES", "TOO_MANY_UNITS");
        POS.message.show(text, "warning", "OK");
        defret.resolve();
        return 0;
    }

    quantity = parseFloat(quantity);
    productId = parseFloat(productId);


    if (this.displayMode == "info") {
        this.displayTarget.productId = productId;

        var sql = "SELECT Text1, Amount_Unit, CorrectedAmount, Unit FROM PROD " +
            "WHERE PROD_ID = " + productId;
        $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
            if (rows.length < 1) {

                var text = POS.lang.getText("MESSAGES", "PRODUCT_NOT_IN_DB");
                if (BonManagerClass.Main.UID == POS.sessions.currentSession)
                    POS.message.show(text, "warning", "");

                defret.resolve();
                return;
            }

            var prodText = rows[0].Text1;
            var correctedPrice = parseFloat(rows[0].CorrectedAmount);
            var prodPrice = float2formatString(rows[0].Amount_Unit);
            if (correctedPrice) {
                prodPrice = "<span style='color:#FF0000'>" +
                    float2formatString(correctedPrice) + "</span>";
            }
            var prodUnit = rows[0].Unit;

            if (correctedPrice)
                prodUnit += "<br>(statt " + rows[0].Amount_Unit + " &euro;)";
            var parameters = Array(prodText, prodPrice, prodUnit);

            if (typeof BonManagerClass.displayTarget.newProdId != "undefined") {
                BonManagerClass.displayTarget.newProdId = productId;
                BonManagerClass.displayTarget.components.okButton.properties.styles.visibility = "visible";
                BonManagerClass.displayTarget.components.okButton.reDraw();
            }

            BonManagerClass.displayTarget.showPrice(parameters);

            defret.resolve();

        });
        return defret.promise();
    }

    if (BonManagerClass.displayMode == "stock") {
        var sql = "SELECT Unit, Text1, InStock FROM PROD INNER JOIN PRODSTOCK " +
            "ON PROD.PROD_ID = PRODSTOCK.PROD_ID WHERE PROD.PROD_ID = " + productId;
        $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
            if (!rows) {
                return;
            }
            if (rows && rows.length < 1) {
                POS.message.show(text, "warning", "");
                var text = POS.lang.getText("MESSAGES", "PRODUCT_NOT_IN_DB");
                return;
            }

            var prodText = rows[0].Text1;
            var prodStock = float2formatString(rows[0].InStock);
            var prodUnit = rows[0].Unit;
            var parameters = Array(prodText, prodStock, prodUnit);

            BonManagerClass.displayTarget.showStock(parameters);
            defret.resolve();
            return;
        });
        return defret.promise();
    }
    sql = "SELECT Type, EAN, AllowComma FROM PROD WHERE PROD_ID = " + productId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        if (rows.length < 1) {

            var text = POS.lang.getText("MESSAGES", "PRODUCT_NOT_IN_DB");
            if (BonManagerClass.Main.UID == POS.sessions.currentSession)
                POS.message.show(text, "warning", "");

            defret.resolve();
            return;
        }

        var prodType = rows[0].Type;
        var barcode = rows[0].EAN;
        var allowComma = rows[0].AllowComma;
        var regExpBarcode = new RegExp("^99[0-9]{10}$", "g");

        if (allowComma == "0" && quantity != Math.floor(quantity)) {

            var text = POS.lang.getText("MESSAGES", "WRONG_QUANTITY");
            if (BonManagerClass.Main.UID == POS.sessions.currentSession)
                POS.message.show(text, "warning", "");

            defret.resolve();
            return;
        }

        BonManagerClass.addEntryPOSQuantity = quantity;
        BonManagerClass.addEntryPOSProductId = productId;
        BonManagerClass.addEntryPOSProductPrice = parseFloat(productPrice);

        if ((prodType == "BFF" || prodType == "NPP") && barcode.match(regExpBarcode) != null) {
            $.when(Trans.isProductInStock(BonManagerClass.currentBonId, productId, quantity)).then(function (val) {
                if (!val) {
                    var text = POS.lang.getText("MESSAGES", "PRODUCT_NOT_IN_STOCK");

                    if (POS.sessions.currentSession == BonManagerClass.Main.UID)
                        POS.message.show(text, "warning", "YESNO", BonManagerClass, BonManagerClass.addEntryPOS);
                    else
                        POS.message.save(BonManagerClass.Main.UID, text, "warning", "YESNO", BonManagerClass, BonManagerClass.addEntryPOS);

                    defret.resolve();
                } else {
                    $.when(BonManagerClass.addEntryPOS(BonManagerClass, "YES")).done(function () {
                        defret.resolve();
                    });
                }
            });

            return defret.promise();
        }
        $.when(BonManagerClass.addEntryPOS(BonManagerClass, "YES", freeProd)).done(function () {
            defret.resolve();
        });

    });
    return defret.promise();
}

CBonEntryOps.prototype.addEntryPOS = function (me, result, freeProd) {
    var BonManagerClass = this;

    var defret = $.Deferred();

    if (result != "YES") {
        defret.resolve();
        return;
    }
    var def2 = $.Deferred();
    var quantity = me.addEntryPOSQuantity;
    var productId = me.addEntryPOSProductId;
    var productPrice = me.addEntryPOSProductPrice;
    if (productPrice)
        me.addEntryPOSProductPrice = null;


    var PrimBonEntry;
    var Found;
    var Refs;

    if (me.currentBonId == 0) {
        var def = me.openBon();
    } else {
        def = 0;
    }
    // Look if we already have entry
    $.when(def).done(function (x) {

        Found = false;
        // create BonEntry

        if (!Found) {
            me.currentIndex++;
            PrimBonEntry = new CBonEntry(me.currentIndex, "POS", "", quantity, "", "", null,
                    0, 0, productId);
            $.when(PrimBonEntry.defreturn).done(function (c) {
                if (productPrice) {
                    PrimBonEntry.unitAmount = productPrice;
                    PrimBonEntry.amount = quantity * productPrice;
                }
                $.when(Trans.addEntry(me.currentBonId, PrimBonEntry)).done(function (id) {
                    $.when(Trans.changeVAT(PrimBonEntry, PrimBonEntry.product.vat)).done(function () {
                        var def3 = $.Deferred();
                        if (freeProd) {
                            // special for free price input
                            $.when(Trans.changeInteraction(PrimBonEntry, "FPR")).done(function () {
                                def3.resolve();
                            });

                        } else {
                            def3 = 0;
                        }
                        // Add BonEntry to Bon

                        $.when(def3).done(function () {
                            me.currentBon[me.currentIndex] = PrimBonEntry;
                            def2.resolve();
                        });
                    });
                });
            });
        } else {
            def2.resolve();
        }

        $.when(def2).done(function () {

            me.Main.InfoIcons.hideIcon("suggestion");

            if (Found)
                me.redrawBonArray[PrimBonEntry.index] = PrimBonEntry;
            else
                me.addNewPos(PrimBonEntry);
            me.Grid.rowSelectInt(me.Grid, me.gridLinksRow[PrimBonEntry.index].rowIndex);
            $.when(Trans.isBarcodeRebate(PrimBonEntry.productId)).then(function (val) {
                if (val)
                    var def2 = me.recalcAll();
                else
                    def2 = me.recalcAuto(PrimBonEntry);
                $.when(def2).then(function () {
                    $.when(me.updateInstantRebate()).then(function () {
                        $.when(me.redrawBonSum()).done(function () {
                            $.when(me.runRedrawBonArray()).done(function () {
                                me.showPos(PrimBonEntry, false); //slow
                                me.Bon.scrollAbs(10000000);

                                defret.resolve();
                            });
                        });
                    });
                });
            });
        });
    });
    return defret.promise();
}

CBonEntryOps.prototype.addEntryFREE = function (price, freeProdId, mode) {

    var defret = $.Deferred();
    var PrimBonEntry;
    var Found;
    var Refs;
    var BonManagerClass = this;

    if (mode != "REC" && mode != "FPR")
        return;

    if (mode == "REC")
        price *= -1;

    if (BonManagerClass.currentBonId == 0) {
        var def = BonManagerClass.openBon();
    } else {
        def = 0;
    }
    $.when(def).done(function (x) {
        // create BonEntry
        BonManagerClass.currentIndex++;
        PrimBonEntry = new CBonEntry(BonManagerClass.currentIndex, mode, "", 1, "", "", null,
                price, price, freeProdId);
        // DB
        $.when(PrimBonEntry.defreturn).done(function (c) {
            $.when(Trans.addEntry(BonManagerClass.currentBonId, PrimBonEntry)).done(function (id) {
                $.when(Trans.changeVAT(PrimBonEntry, PrimBonEntry.product.vat)).done(function () {
                    // Add BonEntry to Bon
                    BonManagerClass.currentBon[BonManagerClass.currentIndex] = PrimBonEntry;

                    BonManagerClass.addNewPos(PrimBonEntry);
                    $.when(BonManagerClass.updateInstantRebate()).done(function () {
                        $.when(BonManagerClass.recalcAuto(PrimBonEntry)).done(function () {
                            $.when(BonManagerClass.redrawBonSum()).done(function () {
                                $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                                    BonManagerClass.showPos(PrimBonEntry, false);

                                    BonManagerClass.Grid.rowSelectInt(BonManagerClass.Grid, BonManagerClass.gridLinksRow[PrimBonEntry.index].rowIndex);
                                    BonManagerClass.Bon.scrollAbs(1000000);

                                    defret.resolve();
                                });
                            });
                        });
                    });
                });
            });
        });

    });
    return defret.promise();
}

// Zentrale Durchsetzung "nur 1 Rabatt pro Bon". Liefert den blockierenden
// Eintrag (oder null). Von addEntryMRB, addEntryGRB/addEntrySubREBS und
// recalcAuto vor jeder NEU-Anlage eines Rabatts aufzurufen.

CBonEntryOps.prototype.preAddEntryQTY = function (reference, quantity) {
    var BonManagerClass = this;
    if (quantity > 999) {
        var text = POS.lang.getText("MESSAGES", "TOO_MANY_UNITS");
        POS.message.show(text, "warning", "OK");
        return;
    }

    var sql = "SELECT EAN FROM PROD WHERE PROD_ID = " + reference.productId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var barcode = rows[0].EAN;
        var regExpBarcode = new RegExp("^99[0-9]{10}$", "g");

        BonManagerClass.addEntryQTYReference = reference;
        BonManagerClass.addEntryQTYQuantity = quantity;

        if (barcode.match(regExpBarcode) != null) {
            $.when(Trans.isProductInStock(BonManagerClass.currentBonId, reference.productId, quantity, reference.dbid)).then(function (val) {
                if (!val)
                {
                    var text = POS.lang.getText("MESSAGES", "PRODUCT_NOT_IN_STOCK");
                    POS.message.show(text, "warning", "YESNO", BonManagerClass, BonManagerClass.addEntryQTY);
                } else
                    BonManagerClass.addEntryQTY(BonManagerClass, "YES");
            });
            return;
        }
        BonManagerClass.addEntryQTY(BonManagerClass, "YES");
    });
}

CBonEntryOps.prototype.addEntryQTY = function (me, result) {

    if (result != "YES")
        return;

    var reference = me.addEntryQTYReference;
    var quantity = me.addEntryQTYQuantity;

    var Amount;

    if (!quantity) {
        var text = POS.lang.getText("MESSAGES", "NO_QTY");
        POS.message.show(text, "warning", "OK");
        return;
    }

    if (!(quantity > 0))
        quantity = 1;
    else
        quantity = Number(quantity);

    if (!reference) {
        text = POS.lang.getText("MESSAGES", "NO_QTY_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return;
    }
    if (reference.type != "POS") {
        text = POS.lang.getText("MESSAGES", "NO_QTY_POS_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return;
    }
    if (!reference.product) {
        text = POS.lang.getText("MESSAGES", "NO_QTY_PRODUCT");
        POS.message.show(text, "critical", "OK");
        return;
    }

    // remove all rebates of this position
    for (var SubBonCnt in reference.referencedBy) {
        var SubBon = reference.referencedBy[SubBonCnt];

        Trans.cancelEntry(SubBon, "QTY");
        if (!SubBon.index)
            SubBon.index = me.currentBon.indexOf(SubBon);
        me.currentBon[SubBon.index] = null;
        delete me.currentBon[SubBon.index];
        reference.referencedBy[SubBonCnt] = null;
        delete reference.referencedBy[SubBonCnt];
    }

    Amount = quantity * reference.unitAmount;
    // update BonEntry
    reference.quantity = quantity;
    reference.amount = fix2Decimals(Amount);
    $.when(Trans.updateEntry(reference, "QTY")).done(function () {

        $.when(me.updateInstantRebate()).done(function () {
            me.redrawBonArray[reference.index] = reference;
            $.when(me.recalcAuto(reference)).done(function () {
                $.when(me.redrawBonSum()).done(function () {
                    $.when(me.runRedrawBonArray()).done(function () {
                        me.showPos(reference, false);
                    });
                });
            });
        });
    });
}

CBonEntryOps.prototype.addEntryPRC = function (reference, amount) {
    var Amount;
    var BonManagerClass = this;
    if (!amount) {
        var text = POS.lang.getText("MESSAGES", "NO_NEW_PRICE_AMOUNT");
        POS.message.show(text, "warning", "OK");
        return;
    }
    if (!reference) {
        text = POS.lang.getText("MESSAGES", "NO_NEW_PRICE_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return;
    }
    if (reference.type != "POS") {
        text = POS.lang.getText("MESSAGES", "NO_NEW_PRICE_POS_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return;
    }
    if (!reference.product) {
        text = POS.lang.getText("MESSAGES", "NO_NEW_PRICE_PRODUCT");
        POS.message.show(text, "critical", "OK");
        return;
    }
    // Check Price and User Right

    if (this.userProps.CHP == 0) {
        text = POS.lang.getText("MESSAGES", "NO_RIGHT_NEW_PRICE");
        POS.message.show(text, "warning", "OK");
        return;
    }

    // amount is new unit amount
    reference.unitAmount = amount;
    // update BonEntry
    reference.amount = fix2Decimals(reference.quantity * amount);
    $.when(Trans.updateEntry(reference, "PRC")).done(function () {
        $.when(BonManagerClass.updateInstantRebate()).done(function () {
            BonManagerClass.redrawBonArray[reference.index] = reference;
            $.when(BonManagerClass.redrawBonSum()).done(function () {
                $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                    BonManagerClass.showPos(reference, false);
                });
            });
        });
    });
}

CBonEntryOps.prototype.addEntryCAN = function (reference) {
    var BonManagerClass = this;
    if (!reference) {
        var text = POS.lang.getText("MESSAGES", "NO_CANCEL_REFERENCE");
        POS.message.show(text, "critical", "OK");
        return;
    }
    // cancel reference
    $.when(Trans.cancelEntry(reference)).done(function () {
        var entries = Trans.collectSubEntries(reference);
        for (rb in entries) {
            entries[rb].cancelled = true;
        }
        if (reference.product && reference.product.vatShortcut) {
            reference.product.vatShortcut = "-";
        }

        BonManagerClass.Main.InfoIcons.hideIcon("suggestion");

        BonManagerClass.redrawBonArray[reference.index] = reference;
        $.when(BonManagerClass.updateInstantRebate()).done(function () {
            $.when(BonManagerClass.recalcAuto(reference)).done(function () {
                $.when(BonManagerClass.redrawBonSum()).done(function () {
                    $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                        BonManagerClass.showPos(reference, true);

                    });
                });
            });
        });
    });
}

CBonEntryOps.prototype.addNewPos = function (Entry) {
    this.gridLinks[Entry.index] = new CPre();
    var Row = this.Grid.addRowWithComponent(this.gridLinks[Entry.index], true);
    this.gridLinksRow[Entry.index] = Row;
    this.gridLinksHeights[Entry.index] = 0;
    this.redrawBonArray[Entry.index] = Entry;
}

CBonEntryOps.prototype.getSelectedItem = function (dontcheck) {
    var Entry = null;
    if (dontcheck) {
        return null;
    }

    if (this.Grid.selectedRowIndex == -1) {
        if (typeof this.comesFromId == "undefined" || !this.comesFromId) {
            var text = POS.lang.getText("MESSAGES", "NO_BON_POSITION_SELECTED");
            POS.message.show(text, "warning", "OK");
        }
        this.comesFromId = false;
        return null;
    }

    var SelectedObject =
        this.Grid.rows[this.Grid.selectedRowIndex].row.children[0].children[0];
    for (var cnt in this.gridLinks) {
        if (this.gridLinks[cnt] == SelectedObject) {
            Entry = this.currentBon[cnt];
            break;
        }
    }
    return Entry;
}

CBonEntryOps.prototype.removePos = function () {
    var Entry = this.getSelectedItem();
    if (!Entry)
        return;

    this.addEntryCAN(Entry);
}

CBonEntryOps.prototype.correctQty = function (quantity) {
    var Entry = this.getSelectedItem();
    if (!Entry)
        return;

    this.preAddEntryQTY(Entry, quantity);
}

CBonEntryOps.prototype.correctPrc = function (amount) {
    var Entry = this.getSelectedItem();
    if (!Entry)
        return;
    this.addEntryPRC(Entry, amount);
}

CBonEntryOps.prototype.cancelEntry = function (Entry) {
    this.addEntryCAN(Entry);
}

CBonEntryOps.prototype.getProductName = function () {
    var numPos = 0;

    for (var cnt in this.currentBon) {
        var Entry = this.currentBon[cnt];
        if (Entry.type == "POS" && !Entry.cancelled) {
            numPos++;
            var prodName = Entry.text1;
            if (numPos > 1)
                return false;
        }
    }
    return prodName;
}

CBonEntryOps.prototype.addDelivery = function (lines, ts) {
    var BonManagerClass = this;
    $.when(Trans.addDeliveryBon(ts)).then(function (idBon) {
        for (var i = 0; i < lines.length; i++) {
            if (!lines[i])
                continue;
            var arr = lines[i].split(";");
            if (arr && arr.length > 1) {
                Trans.addDeliveryEntry(ts, idBon, arr);
            }
        }

        Trans.closeDeliveryBon(idBon);

        try {
            BonManagerClass.acceptDelivery(idBon);
        } catch (e) {
            log.add(2, "Error", "Could not update ProdStock for deliver " + idBon, e);
            return false;
        }
    });
}

// Logik liegt jetzt headless in frontend/src/domain/stock.js (behebt den
// Closure-Bug des alten Codes: bei mehreren Positionen verbuchten alle
// PRODSTOCK-Updates die Werte der letzten Position - siehe Testfall
// "Lieferschein: Bestandsfortschreibung bei MEHREREN Positionen").
CBonEntryOps.prototype.acceptDelivery = function (idBon) {
    window.StockDomain.applyDelivery(idBon);
}

CBonEntryOps.prototype.checkThreshold = function (min, max, percent, sum) {
    var params = new Array();
    var envProp = "CUSTOMERPERCENTMARGIN" + max + "EUR";
    if (typeof POS.EnvProperties[envProp] != "undefined") {
        if (sum >= min && sum < max && (max - sum) <= (POS.EnvProperties[envProp] / 100 * max)) {
            params[0] = max - sum;
            params[1] = percent;
        }
    }
    return params
}

CBonEntryOps.prototype.checkCustomerThresholdPrice = function () {
    var thresholdParams = new Array();
    var BonManagerClass = this;
    var dfd = jQuery.Deferred();
    if (this.currentCustomerId) {
        $.when(this.extractRebateSum()).then(function (sumBrutto) {

            for (i in BonManagerClass.rebateZones) {
                var rZ = BonManagerClass.rebateZones[i];
                var nextRZ = BonManagerClass.rebateZones[parseInt(i) + 1];
                if (rZ.max && nextRZ) {
                    thresholdParams = BonManagerClass.checkThreshold(rZ.min, rZ.max, nextRZ.percent, sumBrutto);
                    if (thresholdParams.length != 0)
                        break;
                }
            }

            dfd.resolve(thresholdParams);
        });
    } else {
        dfd.resolve(0);
    }
    return dfd.promise();
}

export { CBonEntryOps };
